import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { flexCenter } from '../styles/mixins';
import { UmbrellaIconProps } from './UmbrellaIcon';
import { StylesIndexInjections } from 'common-react';

export interface StyleProps extends UmbrellaIconProps {
  color?: string;
  isDarkTheme?: boolean;
  bgColor?: string;
}

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    ...flexCenter(),
    width: ({width}:UmbrellaIconProps) => width,
    height: ({height}:UmbrellaIconProps) => height,
    textAlign: 'center',
    lineHeight: ({height}:StyleProps) => `${height}px`,
    '& > svg path': {
      stroke: ({color}:UmbrellaIconProps) => color || theme.color.greys[80],
    },
    '& > svg path:first-of-type': {
      fill: ({color}:UmbrellaIconProps) => color || theme.color.greys[80],
    },
  },

}), { name: 'UmbrellaIcon', index: StylesIndexInjections.UI_MOLECULES });
